var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImgLogoGithub = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 27.5,
  fill: "#fff",
  stroke: "#E6E9EE"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_logo_github_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28 12c-8.84 0-16 7.16-16 16 0 7.072 4.587 13.063 10.942 15.185.795.147 1.09-.344 1.09-.776 0-.383-.01-1.385-.02-2.72-4.45.962-5.392-2.142-5.392-2.142-.727-1.847-1.778-2.347-1.778-2.347-1.453-.992.108-.973.108-.973 1.601.118 2.456 1.65 2.456 1.65 1.424 2.446 3.742 1.739 4.655 1.326.148-1.031.56-1.738 1.012-2.141-3.546-.393-7.278-1.768-7.278-7.897 0-1.748.619-3.172 1.65-4.292-.167-.413-.717-2.033.147-4.233 0 0 1.346-.433 4.4 1.64A15.526 15.526 0 0 1 28 19.74c1.355.01 2.73.186 4.007.54 3.055-2.073 4.4-1.64 4.4-1.64.875 2.2.325 3.83.158 4.233 1.021 1.12 1.64 2.544 1.64 4.292 0 6.149-3.742 7.494-7.307 7.897.57.491 1.09 1.473 1.09 2.966 0 2.141-.02 3.86-.02 4.39 0 .433.285.924 1.1.767C39.423 41.063 44 35.072 44 28.01 44 19.16 36.84 12 28 12Z",
  fill: "#1A1414"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_logo_github_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(12 12)",
  d: "M0 0h32v32H0z"
})))));

export default SvgImgLogoGithub;